import { render, staticRenderFns } from "./r-icon-button.vue?vue&type=template&id=6387d89a&shadow"
import script from "./r-icon-button.vue?vue&type=script&lang=js&shadow"
export * from "./r-icon-button.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./r-icon-button.vue?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports